import { enableSignupRefererForwarding } from '@gonfalon/dogfood-flags/dogfood-flags';

export const AGENT_SOURCE_VALUE = 'agent';
export const LD_SITE_SOURCE_VALUE = 'ldwebsite';

const AGENT_UTM_PARAMS = {
  utm_source: 'agent',
  utm_medium: 'product',
  utm_campaign: 'agent_onb',
} as const;

const LD_SITE_UTM_PARAMS = {
  utm_source: 'website',
  utm_medium: 'web',
  utm_campaign: 'agent_onb',
} as const;

/**
 * Builds a customReferer URL string for the signup POST body.
 * When the signup was initiated by the agent (source=agent) or the LD
 * website (source=ldwebsite), the UTM parameters are baked into the
 * referer so they flow through the existing referer pipeline without
 * mutating the browser URL.
 */
export function buildSignupCustomReferer(searchParams: URLSearchParams): string {
  const base = window.location.href;

  const source = searchParams.get('source');
  let utmParams;
  if (source === AGENT_SOURCE_VALUE) {
    utmParams = AGENT_UTM_PARAMS;
  } else if (source === LD_SITE_SOURCE_VALUE) {
    utmParams = LD_SITE_UTM_PARAMS;
  } else {
    return base;
  }

  const url = new URL(base);
  for (const [key, value] of Object.entries(utmParams)) {
    if (!url.searchParams.has(key)) {
      url.searchParams.set(key, value);
    }
  }
  return url.toString();
}

export function getForwardedReferer(
  searchParams: URLSearchParams = new URLSearchParams(window.location.search),
): string {
  const existingReferer = searchParams.get('referer');
  return existingReferer ?? buildSignupCustomReferer(searchParams);
}

export function getSignupAttributionSearchParams(): Record<string, string> {
  const search: Record<string, string> = {};
  const referer = enableSignupRefererForwarding() ? getForwardedReferer() : window.location.href;

  if (referer) {
    search.referer = referer;
  }

  if (window.location.pathname.includes('signup-agentcontrol')) {
    search.signup_source = 'agent-control';
  }

  return search;
}
